module.exports = __webpack_public_path__ + "static/media/Mush_Mozza-dt-fr.621318ca.jpg";